import { Link } from '../../../components/Link';
import { Layout } from '../../../queries/ats/layout/types';
import { getMenuPath } from '../../../utils/atsLayoutUtils';

interface MenuLinkProps extends React.ComponentPropsWithoutRef<'a'> {
  children: React.ReactNode;
  type: Layout.SectionItemType;
  slug: string;
}

export function MenuLink({ type, slug, children, onClick, ...rest }: MenuLinkProps) {
  const path = getMenuPath(slug, type);
  return (
    <Link to={path} {...rest}>
      {children}
    </Link>
  );
}
